<template>
<div class="chapter">
<div class="inner_page">
<div class="boxch">
<h1 class="fm-title" id="fm-1"><a id="page_vi"><strong>Preface</strong></a></h1><a id="page_vi">
</a></div><a id="page_vi">
<p class="fpara"><span class="dropcap">I</span>N 1976 I HAD THE HAPPY EXPERIENCE OF BEING GUEST professor at Trinity Evangelical Divinity School in Deerfield, Illinois. Among other things I was asked to teach a class in Johannine Theology. This proved to be one of the most stimulating classes it has ever been my privilege to teach. I do not know whether my students learned anything, but they certainly taught me a lot. And they did more. They instilled in me the desire to write something on the theology of John. Throughout the years I have had the pressure of other commitments and have not been able to get round to it. But now, after all too long a time, I want to pay my tribute to my class of 1976 and to express something of what I have learned from the teachings of John.</p>
<p class="indent-para">It would have been possible to take in all the Johannine writings and say something about what most modern writers see as the Johannine school. But that would have involved discussion of questions of authorship and the like, and I do not care at this time to be sidetracked into such questions, important though they undoubtedly are. This book is simply a series of essays concerned with some of the teachings of our Fourth Gospel. I have not tried to make it exhaustive, and doubtless many of my readers will think of things that I should have included. I have simply taken John’s declared aim (20:31) and tried to show a little of the way that aim was accomplished.</p>
<p class="indent-para">Here then is my little tribute to the class of ’76. I trust that it will prove of interest to other students of the Johannine writings.</p>
<p class="para-right-t">LEON MORRIS</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Preface.vue?6183b6de